import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import SharePlusModal from 'pages/Projects/Tools/Share/SharePlusModal';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';

export const NotesActionButton = ({ createNote, createSection }) => {
  const [showSharePlusModal, toggleSharePlusModalOpen] = useState(false);
  const [showActionOptions, toggleActionDropdown] = useState(false);

  // #TODO: This can possibly be refactored into a reducer so it can be accessed
  // via global state rather than duplicating this logic where it is needed.
  // Share permissions.
  const { personas } = useSelector((state) => state.global.userInfo);
  const { isOrgOwner, isOrgMember } = personas || {};
  const isInOrg = isOrgOwner || isOrgMember;
  const { features } = useSelector((state) => state.projectTools.project || {});
  const notesFeature = useMemo(
    () => Array.isArray(features) ?
      features.find(feat => feat.id === 'notes_enabled') : null,
    [features],
  );
  const designStudioFeature = useMemo(
    () => Array.isArray(features) ?
      features.find(feat => feat.id === 'design_studio_enabled') : null,
    [features],
  );
  const { features: featuresReleased } = useSelector((state) => state.projects.currentProject);
  const { designStudioReleased, notesReleased } = featuresReleased || {};
  // Only show share plus if notes is enabled and is released
  // or studio share is enabled and is released.
  const showShare = notesFeature?.checked && (isInOrg || notesReleased);
  const showSharePlus =  showShare ||
    (designStudioFeature?.checked && (isInOrg || designStudioReleased));

  const show = () => {
    toggleActionDropdown(!showActionOptions);
  };

  const dismiss = () => {
    toggleActionDropdown(false);
  };

  const createNewNote = () => {
    createNote();
    dismiss();
  };

  const renderActionMenu = () => {
    return (
      <>
        {createNote && (
          <button
            className={clsx(
              'action_buttons__button',
              'button--unstyled',
              'button--menu',
            )}
            onClick={createNewNote}
          >
            Add new note
          </button>
        )}
        {createSection && (
          <button
            className={clsx(
              'action_buttons__button',
              'button--unstyled',
              'button--menu',
            )}
            onClick={() => {
              createSection();
              dismiss();
            }}
          >
            Add new section
          </button>
        )}
        {showSharePlus && (
          <button
            className={clsx(
              'action_buttons__button',
              'button--unstyled',
              'button--menu',
            )}
            onClick={() => {
              toggleSharePlusModalOpen(true);
              dismiss();
            }}
          >
            Share +
          </button>
        )}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button button--md button--action">
      <span className="visually-hidden--mobile">Actions</span>
      {showActionOptions ? (
        <MdKeyboardArrowUp size={16} />
      ) : (
        <MdKeyboardArrowDown size={16} />
      )}
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={showActionOptions}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
      >
        {renderActionMenu()}
      </APResponsiveDropdown>
      {showSharePlusModal && (
        <SharePlusModal
          open={showSharePlusModal}
          onClose={() => toggleSharePlusModalOpen(false)}
        />
      )}
    </>
  );
};
